import React, { useEffect, Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Home = lazy(() => import("./Pages/Home"));
const OurStory = lazy(() => import("./Pages/Ourstory"));
const BollywoodKids = lazy(() => import("./Pages/Classes/Bollywood"));
const ZumbaClasses = lazy(() => import("./Pages/Classes/ZumbaClasses"));
const Faqs = lazy(() => import("./Pages/Faqs"));
const NotFound = lazy(() => import('./Pages/NotFound'));
const Contactus = lazy(() => import("./Pages/Contactus"));
const Blog = lazy(() => import("./Pages/Blog"));
const BlogDetails = lazy(() => import("./Pages/BlogDetails"));
const ClassSchedule = lazy(() => import("./Pages/Classes/Classschedule"));
const KidsDance = lazy(() => import("./Pages/PrivateParties/KidsDance"));
const WeddingDance = lazy(() => import("./Pages/PrivateParties/WeddingDance"));
const PrivateParties = lazy(() => import("./Pages/PrivateParties/PrivateParties"));
const TeamBuilding = lazy(() => import("./Pages/PrivateParties/TeamBuilding"));
const Retreats = lazy(() => import("./Pages/Corporates/Retreats"));
const EmployeeWellness = lazy(() => import("./Pages/Corporates/EmployeeWellness"));
const Joinus = lazy(() => import("./Pages/Joinus"));
const Thankyou = lazy(() => import("./Pages/Thankyou"));
const Pricing = lazy(() => import("./Pages/Pricing"));
const LandingPage = lazy(() => import("./Pages/LandingPage"));
const BollyChoreo = lazy(() => import("./Pages/bollychoreo-orchard"));
const Ambassadors = lazy(() => import("./Pages/Ambassadors"));
const BollyFreak = lazy(() => import("./Pages/BollyFreak"));
const CorporateTeamBuilding = lazy(() => import("./Pages/PrivateParties/team-building"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Suspense fallback={<div style={{ textAlign: "center", padding: "50px" }}>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/faq" element={<Faqs />} />
            <Route path="/zumba-classes" element={<ZumbaClasses />} />
            <Route path="/bollywood-for-kids" element={<BollywoodKids />}/>
            <Route path="/contact-us" element={<Contactus />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetails />} />
            <Route path="/class-schedule" element={<ClassSchedule />} />
            <Route path="/kids-dance-classes-and-parties" element={<KidsDance />} />
            <Route path="/wedding-dance" element={<WeddingDance />} />
            <Route path="/private-parties-and-lessons" element={<PrivateParties />} />
            <Route path="/team-building-workshops" element={<TeamBuilding />} />
            <Route path="/retreats" element={<Retreats />} />
            <Route path="/employee-wellness" element={<EmployeeWellness />} />
            <Route path="/join-us" element={<Joinus />} />
            <Route path="/thank-you" element={<Thankyou />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/landing-page" element={<LandingPage />} />
            <Route path="/bollychoreo-orchard" element={<BollyChoreo />} />
            <Route path="/our-ambassadors" element={<Ambassadors />} />
            <Route path="/bollyfreak-training" element={<BollyFreak />} />
            <Route path="/corporate-team-building" element={<CorporateTeamBuilding />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}
export default App;